<template>
  <div>
    <head-nav-bar title="加收房费" :fixed="true" />
    <div class="mt-header-nav">
      <van-row>
        <van-col span="8">房号</van-col>
        <van-col span="8">加收金额</van-col>
        <van-col span="8">加收类型</van-col>
      </van-row>
      <!-- <van-row>
        <van-col span="8">2005</van-col>
        <van-col span="8">155.00</van-col>
        <van-col span="8">加收类型</van-col>
      </van-row>
      <van-row>
        <van-col span="8">2005</van-col>
        <van-col span="8">155.00</van-col>
        <van-col span="8">加收类型</van-col>
      </van-row> -->
      <van-row v-for="(item, index) in list" :key="index">
        <van-col span="8">{{ item.RoomNo }}</van-col>
        <van-col span="8">{{ item.IncreaseAmount }}</van-col>
        <van-col span="8">{{ item.IncreaseTypeText }}</van-col>
      </van-row>
      <van-goods-action>
        <van-goods-action-button
          type="info"
          text="是"
          style="width:50%"
          @click="onRentIncrease()"
        />
        <van-goods-action-button
          type="danger"
          text="否"
          style="width:50%"
          :disabled="!$auth('GuestRoomManage:AddDayRent')"
          @click="onCancleRentIncrease()"
        />
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import orderApi from "../../api/order.js";
import { Row, Col, GoodsAction, GoodsActionButton } from "vant";
import { jump } from "../../utils/common";
export default {
  name: "OrderAddRoomCost",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  props: {},
  data() {
    return {
      orderInfo: {},
      list: [],
      type: "",
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.id;
    this.type = this.$route.query.type;
    this.init();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    init() {
      orderApi.getOrderDetail({ id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        //判断是否加收房费
        this.verificationTimeOut();
      });
    },
    //判断是否加收房费
    verificationTimeOut() {
      let json = { OrderId: this.orderId, RoomNos: [] };
      this.orderInfo.Details.forEach(item => {
        json.RoomNos.push(item.RoomNo);
      });
      orderApi.verificationTimeOut(json).then(res => {
        if (res.Data.RentList && res.Data.RentList.length > 0) {
          let rentIncreaseData = [];
          for (let index = 0; index < res.Data.RentList.length; index++) {
            if (
              res.Data.RentList[index].IsIncrease == 1 ||
              res.Data.RentList[index].IsIncrease == "1"
            ) {
              rentIncreaseData.push(res.Data.RentList[index]);
            }
          }
          this.list = rentIncreaseData;
        }
      });
    },
    //加收房费
    onRentIncrease() {
      orderApi.rentIncrease({ RentList: this.list }).then(() => {
        jump("OrderCheckOut", { id: this.orderId, type: this.type });
      });
    },
    //取消加收房费
    onCancleRentIncrease() {
      jump("OrderCheckOut", { id: this.orderId, type: this.type });
    },
  },
};
</script>

<style scoped>
.van-row {
  padding: 5px 10px;
  text-align: left;
  font-size: 14px;
}
</style>
